import mixins from '../../mixins'

const generateUID = mixins.generateUID.methods.generateUID

export default {
  isEditMode: true,
  pageProperties: {
    pages: [
      {
        pageName: 'home',
        pageId: 1,
        sections: [
          {
            sectionId: 'a0us1n',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            fields: [
              {
                fieldId: 'vas2fp',
                fieldType: 'multi-campaign'
              }
            ]
          }
        ]
      },
      { // ColgateWhiteMoneyBack2025 campaign
        pageName: 'ColgateWhiteMoneyBack2025',
        pageId: 28972,
        isPublic: true,
        sections: [
          {
            sectionId: 'orbg8s',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'refresh-token',
                fieldId: 'ij3433'
              },
              {
                fieldId: 'dte-003',
                fieldType: 'dataLayer-event',
                properties: {
                  eventName: 'PageView',
                  fbEvent: 'PageView'
                }
              },
              {
                fieldType: 'key-visual',
                fieldId: '296eg1',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  styles: {
                    margin: '2% 0 0 0',
                    padding: '0'
                  },
                  imageStyles: {
                    borderRadius: '16px'
                  },
                  containerClass: 'd-flex justify-content-center',
                  noContainer: false,
                  addRow: true,
                  desktopImageUrl: '/assets/campaigns/ColgateWhiteMoneyBack2025/key-visual.jpg',
                  mobileImageUrl: '/assets/campaigns/ColgateWhiteMoneyBack2025/key-visual.jpg'
                }
              },
              {
                fieldType: 'participa',
                fieldId: 'acsh315',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  color: '#561617',
                  buttonClass: 'btn-dark-red-radial',
                  nextPage: 'ColgateWhiteMoneyBack2025/InscrieBonul',
                  campaign: 'ColgateWhiteMoneyBack2025',
                  borderColor: 'rgba(215, 199, 240, 0.5)',
                  steps: [
                    {
                      title: 'Pasul 1',
                      text: 'Cumpara produse Colgate Max Ultra White.',
                      image: 'select'
                    },
                    {
                      title: 'Pasul 2',
                      text: 'Încarcă bonul fiscal/factura',
                      image: 'receipt'
                    },
                    {
                      title: 'Pasul 3',
                      text: 'Inregistreaza-te',
                      image: 'register'
                    },
                    {
                      title: 'Pasul 4',
                      text: 'Primesti banii inapoi',
                      image: 'reward'
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        pageName: 'ColgateWhiteMoneyBack2025/InscrieBonul',
        pageId: 22345,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'step-counter',
                fieldId: 'tj4j49',
                properties: {
                  activeIndex: 1,
                  colorSchema: '#DB0811',
                  stepShadow: '#CBD5E0',
                  startGradient: '#E3D3D3',
                  endGradient: '#DB0811',
                  completedGradient: 'radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%)',
                  steps: [
                    {
                      title: 'Cumpara produse Colgate Max Ultra White',
                      page: 'Cumpara produse Colgate Max Ultra White'
                    },
                    {
                      title: 'Incarca bonul fiscal',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    },
                    {
                      title: 'Inregistreaza-te',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    },
                    {
                      title: 'Primesti banii inapoi',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Incarca bonul fiscal/factura</h1>',
                  styles: {
                    fontFamily: 'Plus Jakarta Sans;',
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'La acest pas, te rugăm să încarci dovada achiziționării produselor Colgate Max Ultra White.',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text: 'Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii.',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'receipt-processor',
                      fieldId: 'klvakj',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#561617',
                        fileUploadColor: 'rgba(0, 0, 0, 0.5)',
                        borderColor: '#718096',
                        buttonClass: 'btn-dark-red-radial',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        successAction: {
                          fn: 'goToPage',
                          params: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                        },
                        campaignId: 'colgatemb-ro-2025',
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        eraseColor: '#ffffff',
                        eraseSize: 12,
                        cropColor: '#F27B26',
                        cropBackground: 'rgba(0,0,0,0.6)',
                        cropTitle: 'Decupeaza',
                        eraseTitle: 'Acopera',
                        dragTitle: 'Deplaseaza imaginea',
                        zoomInTitle: 'Mareste',
                        zoomOutTitle: 'Micsoreaza',
                        selectImageTitle: 'Select an Image',
                        selectAnotherTitle: 'Select Another',
                        controlsBackground: '#561617',
                        backgroundColorBtn: 'black',
                        textColor: '#141414'
                      }
                    },
                    {
                      fieldType: 'empty-bucket',
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: 'receipt-information',
                            fieldId: '5mq1p6',
                            properties: {
                              grid: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                columns: '12'
                              },
                              styles: {
                                textAlign: 'left'
                              },
                              color: '#561617',
                              textColor: '#0E1B17',
                              descriptionTextColor: '#00291C',
                              descriptionText: 'Nu se accepta bonuri sau facturi pliate/indoite sau scanate',
                              receiptImage: 'receipt37',
                              receiptIsSvg: true,
                              steps: [
                                {
                                  text: 'Numele magazinului',
                                  label: 'A'
                                },
                                {
                                  text: 'Produsele participante si pretul lor',
                                  label: 'B'
                                },
                                {
                                  text: 'Suma totala a bonului/facturii in LEI',
                                  label: 'C'
                                },
                                {
                                  text: 'Data si ora de pe bon sau factura',
                                  label: 'D'
                                },
                                {
                                  text: 'Numarul bonului fiscal/facturii',
                                  label: 'E'
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'bsbsd35',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'receipt-image-information'
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '40px'
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm1',
                properties: {
                  grid: {
                    columns: '0'
                  },
                  addClass: 'btn-link',
                  text: 'Inapoi',
                  disabled: false,
                  styles: {
                    position: 'absolute;',
                    left: 0
                  },
                  action: {
                    fn: 'goToPage',
                    params: 'ColgateWhiteMoneyBack2025'
                  }
                }
              },
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Continua',
                  addClass: 'btn-dark-red-radial',
                  shouldCheckCrop: true,
                  requires: ['klvakj'],
                  action: {
                    fn: 'sendReceipt',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        pageName: 'ColgateWhiteMoneyBack2025/Inregistreaza',
        pageId: 634553232,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'step-counter',
                fieldId: 'tj4j49',
                properties: {
                  activeIndex: 2,
                  colorSchema: '#DB0811',
                  stepShadow: '#CBD5E0',
                  startGradient: '#E3D3D3',
                  endGradient: '#DB0811',
                  completedGradient: 'radial-gradient(173.75% 424.92% at 50% 50.57%, #DB0811 0%, #FFC6CF 44.85%, #A26971 100%)',
                  steps: [
                    {
                      title: 'Cumpara produse Colgate Max Ultra White',
                      page: 'Cumpara produse Colgate Max Ultra White'
                    },
                    {
                      title: 'Incarca bonul fiscal',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    },
                    {
                      title: 'Inregistreaza-te',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    },
                    {
                      title: 'Primesti banii inapoi',
                      page: 'ColgateWhiteMoneyBack2025/Inregistreaza'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'fckzg7',
                properties: {
                  text: '<h1>Formular de inscriere</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '40px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--maxWidth': '545px',
                    '--backgroundColor': '#EDF2F7'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'ColgateWhiteMoneyBack2025/Multumim'
                  },
                  endpoint: '/register',
                  // gReCaptcha3: true,
                  multiFactorAuth: true,
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: 'Introdu prenumele',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: 'Introdu numele',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: 'Introdu e-mailul',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: 'Introdu numarul de telefon',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldType: 'google-recaptcha-v2'
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, in cazul in care esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 7.3.3/8.2/11.2 din Regulamentul acestei campanii.',
                        grid: {
                          columns: '12',
                          marginTop: '35px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    },
                    {
                      fieldId: 'wgc3j7',
                      fieldType: 'checkbox',
                      properties: {
                        name: 'terms',
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: 'Termenii si conditiile sunt necesare',
                        grid: {
                          columns: '12',
                          paddingTop: '10px'
                        },
                        styles: {
                          marginTop: '30px',
                          '--color': '#2E2E2E',
                          '--checkedCheckbox':
                            'url(/assets/icons/form/checked_checkbox.svg)',
                          '--uncheckedCheckbox':
                            'url(/assets/icons/form/unchecked_checkbox.svg)'
                        },
                        label: `Confirm ca am peste 18 ani. Confirm <a href="/files/ColgateWhiteMoneyBack2025Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '120px'
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm1',
                properties: {
                  grid: {
                    columns: '0'
                  },
                  addClass: 'btn-link',
                  text: 'Inapoi',
                  disabled: false,
                  styles: {
                    position: 'absolute;',
                    left: 0
                  },
                  action: {
                    fn: 'goToPage',
                    params: 'ColgateWhiteMoneyBack2025/InscrieBonul'
                  }
                }
              },
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-dark-red-radial',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        pageName: 'ColgateWhiteMoneyBack2025/Multumim',
        pageId: 99800,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'ColgateWhiteMoneyBack2025',
                  campaignName: 'Campania Nationala Colgate Max White Ultra Money Back',
                  haveActivator: false,
                  borderColor: '#56161740',
                  textColor: '#00291C',
                  textBeforeReferenceColor: '#828282',
                  referenceColor: '#E31F26',
                  copyImageSrc: '/assets/icons/copy.svg'
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        pageName: 'ColgateWhiteMoneyBack2025/WinnerPage',
        isPublic: true,
        pageId: 6345513,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'basb782',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'vasv24',
                properties: {
                  variables: [
                    {
                      query: 'customerToken',
                      state: 'customerToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'receiptToken',
                      state: 'receiptToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#141414'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '50px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--backgroundColor': '#EDF2F7'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'ColgateWhiteMoneyBack2025/WinnerThankYou'
                  },
                  endpoint: '/winnerRegister',
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf8',
                      fieldType: 'text-input',
                      properties: {
                        name: 'address',
                        label: 'Adresa',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredAdress|adress',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '*strada, numar, bloc, scara, apartament',
                        grid: {
                          columns: '12',
                          marginTop: '20px;',
                          marginBottom: '20px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: 'bdsb632',
                      fieldType: 'select-input-county',
                      properties: {
                        name: 'judet',
                        label: 'Judet',
                        placeholder: 'Judet',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredJudet',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'bask257',
                      fieldType: 'select-input-city',
                      properties: {
                        name: 'localitate',
                        label: 'Localitate',
                        placeholder: 'Localitate',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredLocal',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'acasg235',
                      fieldType: 'text-input',
                      properties: {
                        name: 'postal',
                        label: 'Cod postal',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'integer|length:6',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope',
                        disablePaste: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '130px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-dark-red-radial',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner CNP form page
        pageName: 'ColgateWhiteMoneyBack2025/WinnerPageCNP',
        isPublic: true,
        pageId: 634553,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'basb782',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'vasv24',
                properties: {
                  variables: [
                    {
                      query: 'customerToken',
                      state: 'customerToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'receiptToken',
                      state: 'receiptToken'
                    }
                  ]
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#141414'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'ci88zt',
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 4,
              marginTop: '50px'
            },
            container: true,
            fields: [
              {
                fieldType: 'form-component',
                fieldId: 'j765n4b',
                properties: {
                  styles: {
                    margin: '0',
                    justifyContent: 'center',
                    '--backgroundColor': '#EDF2F7'
                  },
                  grid: {
                    alignItems: 'center',
                    columns: '0',
                    justifyContent: 'center'
                  },
                  requires: ['1'],
                  successAction: {
                    fn: 'goToPage',
                    params: 'ColgateWhiteMoneyBack2025/WinnerThankYou'
                  },
                  endpoint: '/winnerRegister',
                  fields: [
                    {
                      fieldId: 'b4baqs',
                      fieldType: 'text-input',
                      properties: {
                        name: 'surname',
                        autocomplete: 'no',
                        label: 'Prenume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          alignItems: 'center',
                          justifyContent: 'center',
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'gofije',
                      fieldType: 'text-input',
                      properties: {
                        name: 'name',
                        autocomplete: 'no',
                        label: 'Nume',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|onlyLetters',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf9',
                      fieldType: 'text-input',
                      properties: {
                        name: 'email',
                        label: 'E-mail',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|email',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'vake42c',
                      fieldType: 'text-input',
                      properties: {
                        name: 'mobile',
                        label: 'Numar de telefon',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'required|phoneNumber',
                        grid: {
                          columns: 12
                        },
                        autocomplete: 'nope',
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'h7kzf8',
                      fieldType: 'text-input',
                      properties: {
                        name: 'address',
                        label: 'Adresa',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredAdress|adress',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'ko3h1sz',
                      fieldType: 'paragraph',
                      properties: {
                        text: '*strada, numar, bloc, scara, apartament',
                        grid: {
                          columns: '12',
                          marginTop: '20px;',
                          marginBottom: '20px'
                        },
                        classes: ['disclaimer'],
                        styles: {
                          color: '#2E2E2E !important'
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: 'bdsb632',
                      fieldType: 'select-input-county',
                      properties: {
                        name: 'judet',
                        label: 'Judet',
                        placeholder: 'Judet',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredJudet',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '30px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'bask257',
                      fieldType: 'select-input-city',
                      properties: {
                        name: 'localitate',
                        label: 'Localitate',
                        placeholder: 'Localitate',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'requiredLocal',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope'
                      }
                    },
                    {
                      fieldId: 'acasg235',
                      fieldType: 'text-input',
                      properties: {
                        name: 'postal',
                        label: 'Cod postal',
                        placeholder: '',
                        text: '',
                        color: '#2E2E2E',
                        validation: 'integer|length:6',
                        grid: {
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        },
                        autocomplete: 'nope',
                        disablePaste: true
                      }
                    },
                    {
                      fieldId: 'bsdy4362',
                      fieldType: 'text-input',
                      properties: {
                        name: 'cnp',
                        autocomplete: 'no',
                        label: 'CNP',
                        placeholder: '',
                        text: '',
                        validation: 'required|integer|length:13',
                        color: '#2E2E2E',
                        grid: {
                          alignItems: 'center;',
                          justifyContent: 'center;',
                          columns: 12
                        },
                        styles: {
                          marginTop: '50px',
                          borderColor: '#ADB5BD'
                        }
                      }
                    },
                    {
                      fieldId: 'bsadbsd325',
                      fieldType: 'checkbox',
                      properties: {
                        name: 'cnpConfirm',
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: 'terms',
                        grid: {
                          columns: '12',
                          paddingTop: '10px'
                        },
                        styles: {
                          marginTop: '30px',
                          '--color': '#2E2E2E',
                          '--checkedCheckbox':
                            'url(/assets/icons/form/checked_checkbox.svg)',
                          '--uncheckedCheckbox':
                            'url(/assets/icons/form/unchecked_checkbox.svg)'
                        },
                        label: `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'yh453gg4',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '130px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'TRIMITE',
                  disabled: false,
                  addClass: 'btn-dark-red-radial',
                  action: {
                    fn: 'sendForm',
                    params: 'j765n4b'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        pageName: 'ColgateWhiteMoneyBack2025/WinnerThankYou',
        pageId: 99830,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you-winner',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'ColgateWhiteMoneyBack2025',
                  campaignName: 'Campania Nationala Colgate Max White Ultra Money Back',
                  haveActivator: false,
                  textColor: '#141414'
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        pageName: 'ColgateWhiteMoneyBack2025/receipt-reupload',
        isPublic: true,
        pageId: 32,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'referenceNumber',
                      state: 'formData'
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: 'Bonul fiscal/factura incarcat/a anterior nu ne este complet/a sau este ilizibil.',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C;'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text:
                    'Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C;'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'receipt-processor',
                      fieldId: 'klvakj',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#561617',
                        fileUploadColor: 'rgba(0, 0, 0, 0.5)',
                        borderColor: '#718096',
                        buttonClass: 'btn-dark-red-radial',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        successAction: {
                          fn: 'goToPage',
                          params: 'ColgateWhiteMoneyBack2025/Multumesc'
                        },
                        campaignId: 'colgatemb-ro-2025',
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        eraseColor: '#ffffff',
                        eraseSize: 12,
                        cropColor: '#F27B26',
                        cropBackground: 'rgba(0,0,0,0.6)',
                        cropTitle: 'Decupeaza',
                        eraseTitle: 'Acopera',
                        dragTitle: 'Deplaseaza imaginea',
                        zoomInTitle: 'Mareste',
                        zoomOutTitle: 'Micsoreaza',
                        selectImageTitle: 'Select an Image',
                        selectAnotherTitle: 'Select Another',
                        controlsBackground: '#561617',
                        backgroundColorBtn: 'black',
                        reUpload: true,
                        tokenName: 'token'
                      }
                    },
                    {
                      fieldType: 'empty-bucket',
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: 'receipt-information',
                            fieldId: '5mq1p6',
                            properties: {
                              grid: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                columns: '12'
                              },
                              styles: {
                                textAlign: 'left'
                              },
                              color: '#561617',
                              textColor: '#141414',
                              descriptionTextColor: '#2E2E2E',
                              descriptionText: 'Nu se accepta bonuri sau facturi pliate/indoite sau scanate',
                              receiptImage: 'receipt37',
                              receiptIsSvg: true,
                              steps: [
                                {
                                  text: 'Numele magazinului',
                                  label: 'A'
                                },
                                {
                                  text: 'Produsele participante si pretul lor',
                                  label: 'B'
                                },
                                {
                                  text: 'Suma totala a bonului/facturii in LEI',
                                  label: 'C'
                                },
                                {
                                  text: 'Data si ora de pe bon sau factura',
                                  label: 'D'
                                },
                                {
                                  text: 'Numarul bonului fiscal/facturii',
                                  label: 'E'
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'bsbsd35',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'receipt-image-information'
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              paddingTop: '60px',
              paddingBottom: '40px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Trimite',
                  addClass: 'btn-dark-red-radial',
                  shouldCheckCrop: true,
                  requires: ['klvakj'],
                  action: {
                    fn: 'sendReceipt',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        pageName: 'ColgateWhiteMoneyBack2025/product-reupload',
        isPublic: true,
        pageId: 1282452,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            headerWrap: true,
            sectionId: 'fu30zq',
            fields: [
              {
                fieldType: 'query-string-to-state',
                fieldId: 'uwxo2o1',
                properties: {
                  variables: [
                    {
                      query: 'referenceNumber',
                      state: 'formData'
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'uwxo2o',
                properties: {
                  text: '<h1>Incarca o poza a produsului</h1>',
                  styles: {
                    color: '#0E1B17'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basv352',
                properties: {
                  text: 'Incarca o poza cu produsele participante la campanie',
                  grid: {
                    marginTop: '15px',
                    marginBottom: '30px'
                  },
                  styles: {
                    fontWeight: '500;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '20px;',
                    color: '#00291C;'
                  }
                }
              },
              {
                fieldType: 'paragraph',
                fieldId: 'basg325',
                properties: {
                  text: 'Doar fisiere JPG, PNG, si PDF sunt acceptate. Fisierul poate avea maxim 16MB.',
                  grid: {
                    marginBottom: '40px'
                  },
                  styles: {
                    fontWeight: '400;',
                    fontFamily: 'Plus Jakarta Sans;',
                    fontSize: '14px;',
                    lineHeight: '20px;',
                    color: '#00291C;'
                  }
                }
              }
            ]
          },
          {
            sectionId: 'dyx8uv',
            grid: {
              columns: 12,
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'empty-bucket',
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: 'center',
                    maxWidth: '1230px'
                  },
                  fields: [
                    {
                      fieldType: 'product-upload',
                      fieldId: 'ase123v',
                      properties: {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        colorSchema: '#561617',
                        borderColor: '#561617',
                        buttonClass: 'btn-dark-red-radial',
                        inputBacgroundColor: '#EDF2F7',
                        grid: {
                          columns: 5,
                          alignItems: 'center',
                          justifyContent: 'center'
                        },
                        endpoint: '/uploadProductPhoto',
                        successAction: {
                          fn: 'goToPage',
                          params: 'ColgateWhiteMoneyBack2025/Multumesc'
                        },
                        phrases: [
                          'Chitanta dvs. este acum incarcata si procesata.',
                          'Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.',
                          'Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou.'
                        ],
                        cornerDetectionPhrases: [
                          'Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.',
                          'Te rugam sa potrivesti bonul in cadran.',
                          'Puteti sterge informatii private cu instrumentul de stergere.'
                        ],
                        reUpload: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: 'hmgwhl',
            grid: {
              columns: 12,
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              marginTop: '60px',
              marginBottom: '30px'
            },
            container: true,
            styles: {
              justifyContent: 'center'
            },
            fields: [
              {
                fieldType: 'button-component',
                fieldId: '16tzm2',
                properties: {
                  grid: {
                    columns: '0',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  text: 'Trimite',
                  addClass: 'btn-dark-red-radial',
                  shouldCheckCrop: false,
                  requires: ['ase123v'],
                  action: {
                    fn: 'sendProductPhotos',
                    params: ''
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        pageName: 'ColgateWhiteMoneyBack2025/Multumesc',
        pageId: 99801,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center'
            },
            container: true,
            fields: [
              {
                fieldType: 'thank-you',
                fieldId: 'gjd10',
                properties: {
                  campaign: 'ColgateWhiteMoneyBack2025',
                  campaignName: 'Campania Nationala Colgate Max White Ultra Money Back',
                  haveActivator: false,
                  borderColor: '#56161740',
                  textColor: '#00291C',
                  textBeforeReferenceColor: '#828282',
                  referenceColor: '#E31F26',
                  copyImageSrc: '/assets/icons/copy.svg'
                }
              }
            ]
          }
        ]
      },
      { // Error page
        pageName: 'ColgateWhiteMoneyBack2025/error-page',
        pageId: 10424,
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'error-page',
                fieldId: 'gjd10',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  showLottie: true,
                  buttonClass: 'btn-dark-red-radial',
                  LottieUrl: '/assets/Lottie/error-Lottie-blue-bear-red-boat.txt'
                }
              }
            ]
          }
        ]
      },
      { // expired page
        pageName: 'ColgateWhiteMoneyBack2025/expired-page',
        pageId: 104224,
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'expired-page',
                fieldId: 'gjd101',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  showLottie: true,
                  buttonClass: 'btn-dark-red-radial',
                  LottieUrl: '/assets/Lottie/expired-link-Lottie.txt'
                }
              }
            ]
          }
        ]
      },
      { // Faq
        pageName: 'ColgateWhiteMoneyBack2025/IntrebariFrecvente',
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12,
              marginBottom: '50px'
            },
            fields: [
              {
                fieldType: 'pdf-viewer',
                fieldId: 'vabd69',
                properties: {
                  grid: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    columns: '12'
                  },
                  link: 'https://jolt-assets.s3.eu-central-1.amazonaws.com/template/promocolgatepalmolive-ro/ColgateWhiteMoneyBack2025/faq.pdf'
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        pageName: 'ColgateWhiteMoneyBack2025/castigatori',
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12,
              marginBottom: '50px'
            },
            fields: [
              {
                fieldType: 'text-list',
                fieldId: 'a6prst',
                properties: {
                  colorSchema: '#000000',
                  title: 'Castigatori',
                  ordered: false,
                  items: [
                    {
                      title: ``
                      // text: `
                      // <ul>
                      //   <li>Cristea Adriana</li>
                      //   <li>Ungureanu andrei</li>
                      //   <li>Bako Ferenc</li>
                      //   <li>Filip Adrian</li>
                      //   <li>Pisaltu Gabriela</li>
                      // </ul>`
                    },
                    {
                      title: ``
                      // text: `
                      // <ul>
                      //   <li>Virga Liviu Mihai</li>
                      //   <li>Vasile Florentina</li>
                      //   <li>Rosioru Marilena</li>
                      //   <li>Arva Iosif</li>
                      //   <li>Ungureanu Liliana</li>
                      //   <li>Iacob Ramona</li>
                      //   <li>Agafitei Danut</li>
                      //   <li>Popescu Emilia Maria</li>
                      //   <li>Iacob Alin</li>
                      //   <li>Arva Sorin</li>
                      //   <li>Virga Cristina</li>
                      //   <li>Reche Mina Nicoleta</li>
                      //   <li>Brailescu Ioana</li>
                      //   <li>Ilie Maria</li>
                      //   <li>Rogojinaru Adriana</li>
                      //   <li>Lazar Oana</li>
                      //   <li>Paduraru Lavinia</li>
                      //   <li>Cristea Stefanut</li>
                      //   <li>Borza Mariana</li>
                      //   <li>Cantoreanu Catrina</li>
                      //   <li>Vacaru Maria</li>
                      //   <li>Mohora Bogdan</li>
                      //   <li>Ungureanu Elena</li>
                      //   <li>Pascalin Danut</li>
                      //   <li>Vacaru Emil</li>
                      //   <li>Vlasceanu Raluca Alexandra</li>
                      //   <li>Chelaru Madalina</li>
                      //   <li>Henteș Bogdan</li>
                      //   <li>Andrei Daniela</li>
                      //   <li>Ungureanu Daniel</li>
                      //   <li>Nica Florin</li>
                      //   <li>Feher Nandor</li>
                      //   <li>Codreanu Geanina</li>
                      //   <li>Petrescu Cristian</li>
                      //   <li>Pisaltu Liviu Constantin</li>
                      //   <li>Barbu Daniela</li>
                      //   <li>Neacsu Adrian</li>
                      //   <li>Ciucioi Elena</li>
                      //   <li>Bako Tunde</li>
                      //   <li>Stancu Gheorghita</li>
                      //   <li>Cojocaru Vasilica</li>
                      //   <li>Arva Maria</li>
                      //   <li>Filip Vasile</li>
                      //   <li>Ungureanu Iulian</li>
                      //   <li>Petcu George</li>
                      //   <li>Mailat Anamaria </li>
                      //   <li>Ciucioi Cristian</li>
                      //   <li>Cristina Luminita Mihaela</li>
                      //   <li>Ungureanu Constantin</li>
                      //   <li>Chirila Ioan</li>
                      // </ul>`
                    }
                  ],
                  grid: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    columns: '8'
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    header: {
      fieldType: 'navbar',
      fieldId: 'cbx34t',
      properties: {
        dataLayer: {
          GTM: {
            Sitelocale: 'ro-ro',
            SiteTouchpoint: '',
            SiteCountry: 'RO',
            SiteBrand: '',
            SiteLanguage: 'RO',
            SitePlatform: '',
            SiteEnvironment: 'Prod',
            SiteHost: 'CTL',
            SiteTechnicalAgency: 'Justsnap',
            SiteStatus: 'Live',
            GoogleAnalyticsLocal: 'UA-15274544-47',
            GoogleAnalyticsBrand: '',
            GoogleAnalyticsSiteSpeedSampleRate: 'high',
            GoogleAnalyticsAllowLinker: 'true',
            GoogleAnalyticsLinkerDomains: '',
            GoogleAnalyticsEnableOptimizely: 'false',
            GoogleAnalyticsConsentRequired: 'true',
            GoogleAnalyticsOptimizeContainerID: '',
            GoogleAnalyticsReportingView: '',
            GoogleReCaptcha: 'true',
            SiteLocalContainer: '',
            FacebookRemarketingID: '270266680523196',
            ConsentOverlay: 'OneTrust',
            ConsentOverlayID: 'htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3',
            SitePrivacyProtection: 'GDPR'
          },
          GTM_CODE: 'GTM-TG4C5LV'
        },
        // "neustar": { //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": { //   init: "270266680523196"
        // },
        title: '',
        color: '#FAF6EE',
        grid: {
          columns: 12
        },
        logo: {
          imageSource: '/assets/logo.svg',
          width: 345,
          alternateText: 'Brand Logo',
          paddingTop: '30px'
        },
        fields: [
          // {
          //   "fieldId": "bsdb35",
          //   "fieldType": "anchor",
          //   "properties": {
          //     "text": "Castigatori",
          //     "url": "/ColgateWhiteMoneyBack2025/castigatori",
          //     "target": "_blank",
          //     "cssClass": "nav-link",
          //     "styles": {
          //       "color": "#050E23",
          //       "fontSize": "18px",
          //       "fontWeight": "400"
          //     }
          //   }
          // },
          {
            fieldId: 'ikz8vc',
            fieldType: 'anchor',
            properties: {
              text: 'Regulament',
              url: '/files/ColgateWhiteMoneyBack2025Regulament.pdf',
              target: '_blank',
              cssClass: 'nav-link',
              styles: {
                color: '#050E23',
                fontSize: '18px',
                fontWeight: '400'
              }
            }
          },
          {
            fieldId: 'slnmdk',
            fieldType: 'anchor',
            properties: {
              text: 'Intrebari frecvente',
              url: '/ColgateWhiteMoneyBack2025/IntrebariFrecvente',
              target: '_blank',
              cssClass: 'nav-link',
              styles: {
                color: '#050E23',
                fontSize: '18px',
                fontWeight: '400'
              }
            }
          }
        ],
        showLine: false,
        meta: [
          { name: 'title', content: 'Protex' },
          {
            name: 'description',
            content: `Protex`
          },
          {
            name: 'keywords',
            content: `Protex`
          }
        ]
      }
    },
    footer: {
      fieldType: 'footer-component',
      fieldId: '4tfbzz',
      properties: {
        links: [{ name: '', link: '' }],
        supportLinks: [
          {
            name: 'Confidentialitate',
            link: 'https://www.jnjconsumer.ro/politica-confidentialitate'
          }
        ],
        styles: {
          color: '#000'
        },
        fields: [
          {
            fieldId: 'ikz8vc1',
            fieldType: 'anchor',
            properties: {
              text: 'Termeni si conditii',
              url: '/files/ColgateWhiteMoneyBack2025Regulament.pdf',
              target: '_blank',
              styles: {
                color: '#40454A'
              }
            }
          },
          {
            fieldId: 'slnmdk2',
            fieldType: 'anchor',
            properties: {
              text: ' Politica de confidentialitate',
              url: 'https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy',
              target: '_blank',
              styles: {
                color: '#40454A'
              }
            }
          }
        ]
      }
    },
    campaignId: 'colgatemb-ro-2025',
    url: 'ColgateWhiteMoneyBack2025',
    name: 'colgatemb-ro-2025'
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'colgatemb-ro-2025',
  campaignURLName: 'ColgateWhiteMoneyBack2025',
  formData: new FormData(),
  campaignStartDate: '2025-06-15',
  campaignEndDate: '2025-08-15',
  showNavLinks: false,
  excludedPages: ['home'],
  cities: [],
  customerMobile: ''
}
